import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeMontant } from '../models/TypeMontant';

@Component({
  selector: 'app-type-montant',
  templateUrl: './type-montant.component.html'
})
export class TypeMontantComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() valeurTotaleEstimee: TypeMontant;

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_TypeMontant';
  }
}
